import { Component, Input, OnInit } from '@angular/core';
import { LoggerService } from 'src/services/logger-services/logger.service';

/**
 * Shared Image Visualization Component
 * 
 * Renders images including:
 * - Base64 encoded images
 * - URL images
 * - Markdown with embedded images
 * 
 * Used by agent and chatbot interfaces to display image content
 */
@Component({
  selector: 'app-shared-image-visualization',
  templateUrl: './image-visualization.component.html',
  styleUrls: ['./image-visualization.component.scss']
})
export class ImageVisualizationComponent implements OnInit {
  /**
   * Image source (can be markdown with base64, HTML with images, or plain base64)
   */
  @Input() imageSource: string = '';
  
  /**
   * CSS class to apply to wrapper
   */
  @Input() wrapperClass: string = 'markdown-answer';
  
  /**
   * Enable scrolling wrapper
   */
  @Input() enableScrolling: boolean = true;
  
  /**
   * Show error state
   */
  showError: boolean = false;
  
  /**
   * Error message to display
   */
  errorMessage: string = '';

  constructor(private readonly logger: LoggerService) {}

  /**
   * Component initialization
   */
  ngOnInit(): void {
    try {
      // Initialization logic if needed
    } catch (error: any) {
      this.logger.logInfo(`Error in ngOnInit: ${error?.message || error}`);
    }
  }

  /**
   * Checks if image source exists and is not empty
   * @returns true if image source is available
   */
  hasImage(): boolean {
    try {
      return !!this.imageSource && this.imageSource.trim().length > 0;
    } catch (error: any) {
      this.logger.logInfo(`Error in hasImage: ${error?.message || error}`);
      return false;
    }
  }

  /**
   * Handles image load error event
   * @param event - Error event from image element
   */
  onImageError(event: Event): void {
    try {
      this.showError = true;
      this.errorMessage = 'Failed to load image';
      this.logger.logInfo(`Image load error: ${JSON.stringify(event)}`);
    } catch (error: any) {
      this.logger.logInfo(`Error in onImageError: ${error?.message || error}`);
    }
  }

  /**
   * Handles successful image load event
   */
  onImageLoad(): void {
    try {
      this.showError = false;
      this.errorMessage = '';
    } catch (error: any) {
      this.logger.logInfo(`Error in onImageLoad: ${error?.message || error}`);
    }
  }
}

